import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=286190eb"
import script from "./confirmOrder.vue?vue&type=script&lang=ts"
export * from "./confirmOrder.vue?vue&type=script&lang=ts"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=286190eb&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports